import {responseTo} from 'interactors/messageBus/create';
import {deviceService} from 'interactors/deviceProxy';

interface Dependencies {
  device?: DeviceService;
}

const RESPONSE = 'no-action-found';

export function fallbackResponse(message: Message, di: Dependencies = {}): void {
  const {device = deviceService} = di;
  if (!device.sendMessage) return;
  device.sendMessage(responseTo(message, RESPONSE));
}
